const locale = {
	MAPPING_TITLE: 'Mapping',
	SEARCH:'Search',
	MAPPING_TITLE_USERS: 'Team Members Mapping',
	MEMBER_MAPPING_VIA_PROJECT: 'Member mapping via project',
	MEMBER_MAPPING_VIA_USER: 'Member mapping via user',
	CREATE_TEAM: 'Create Team',
	ADD_PROJECT_GROUP: 'Add Project Group',
	ADD_SINGLE_PROJECT:'Add Single Project',
	add_member: 'Add Member',
	team_members:'Team Members',
	MAPPING:'Mapping',
	TEAM_MEMBERS_MAPPING: 'Team Members Mapping',
	create_team: 'Create Team',
	team_name: "Team Name",
	enter_team_name: "Enter Team Name",
	user_list:"User List",
	add_project_group: "Add Project Group",
	current_team:"Current Team :",
	current_user:"Current User :",
	group_project_list:"Group Project List",
	search_group_project_list:"Search Group Project List",
	add_single_project: "Add Single Project",
	project_list: "Project List",
	search_project_list: "Search Project List",
	search_project: "Search Project",
	please_write_down_the_name_of_the_team_before_action: 'Please write down the name of the Team before action.',
	view_project: 'View Project',
	view_teams:'View Teams',
	companies:'Companies',
	mapping:'Mapping',
	remove: 'Remove',
	do_you_want_to_remove_this_team :'Do you want to remove this Team ?',
	do_you_want_to_remove_this_project:'Do you want to remove this Project ?',
	do_you_want_to_remove_this_user:'Do you want to remove this User ?',
	please_write_down_the_name_of_the_group_project_or_project_before_action:'Please write down the name of the Group Project or Project before action.',

};

export default locale;
